"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getProvider = exports.getAppointment = exports.deleteAppointment = void 0;
const deleteAppointment = exports.deleteAppointment = '@service/DELETE_APPOINTMENT';
const getAppointment = exports.getAppointment = '@service/GET_APPOINTMENT';
const getProvider = exports.getProvider = '@service/GET_PROVIDER';